export default class Gallery {
	private readonly featured: HTMLImageElement;
	private thumbnailButtons: HTMLElement[];
	constructor() {
		this.featured = document.getElementById(
			"exto-mobile-featured",
		) as HTMLImageElement;
		this.thumbnailButtons = [
			...document.querySelectorAll(".exto-mobile-thumbnail-button"),
		] as HTMLElement[];
		if (!this.featured) {
			throw new Error("Featured image element not present on page");
		}
		this.thumbnailButtons.forEach((thumbnail) =>
			thumbnail.addEventListener("click", () =>
				this.handleClick(thumbnail.dataset),
			),
		);
	}

	/** @param data */
	private handleClick(data: DOMStringMap) {
		const { src, alt } = data;
		this.featured.src = src || "";
		this.featured.alt = alt || "";
	}
}
